import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=7177bdb3&scoped=true"
import script from "./DeleteModal.vue?vue&type=script&lang=js"
export * from "./DeleteModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=7177bdb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7177bdb3",
  null
  
)

export default component.exports